import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { DocumentThumbnail, MiFileInput, MiIcon } from "@miplatform/components";
import { mdiCloseCircle, mdiTrayArrowUp } from "@mdi/js";
import { Box } from "@mui/material";

const CloseoutIssueThumbnail = ({
  documents = [],
  disabled = false,
  onChange,
  onPreview,
  onDelete,
}) => {
  const { theme, classes } = useStyles();
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    setSelectedIndex((currentIndex) =>
      Math.min(currentIndex, Math.max(documents.length - 1, 0))
    );
  }, [documents.length]);

  const handlePreview = (event) => {
    event.stopPropagation();

    if (documents.length > 0) {
      onPreview?.(event, selectedIndex);
    }
  };
  const preview = documents.slice(0, disabled ? 3 : 2);
  const thumbnailCountIndex = disabled ? 3 : 2;
  return (
    <Box className={classes.root}>
      <DocumentThumbnail
        document={documents[selectedIndex]}
        documentCount={1}
        dimension={170}
        aspectRatio={7 / 5}
        onClick={handlePreview}
        style={{
          borderRadius: 3,
          border: documents[selectedIndex]
            ? "none"
            : `1px solid ${theme.palette.grey.main}`,
        }}
      />
      <Box className={classes.thumbnailGrid}>
        {!disabled && (
          <MiFileInput
            disabled={disabled}
            title=""
            onChange={onChange}
            customClassName={classes.uploadButton}
            startIcon={{
              path: mdiTrayArrowUp,
              iconColor: theme.palette.grey.medium,
              iconSize: 1,
            }}
            variant="default"
          />
        )}

        {preview.map((document, index) => (
          <SmallThumbnail
            key={`${document?.referenceId || document?.tempURL || "document"}`}
            document={document}
            selected={index === selectedIndex}
            onClick={handlePreview}
            onDelete={() => onDelete?.(document, index)}
            enableDelete={false}
          />
        ))}

        {documents.slice(thumbnailCountIndex).length > 0 && (
          <SmallThumbnail
            key={`${
              documents[thumbnailCountIndex]?.referenceId ||
              documents[thumbnailCountIndex]?.tempURL ||
              "document"
            }`}
            document={documents[thumbnailCountIndex]}
            selected={false}
            count={documents.length - thumbnailCountIndex}
            onClick={handlePreview}
            onDelete={() =>
              onDelete?.(documents[thumbnailCountIndex], thumbnailCountIndex)
            }
            enableDelete={false}
          />
        )}
      </Box>
    </Box>
  );
};
export default CloseoutIssueThumbnail;

const SmallThumbnail = ({
  document,
  onClick,
  selected,
  count,
  onDelete,
  enableDelete = false,
}) => {
  const { theme, classes } = useStyles();
  return (
    <Box>
      {enableDelete && (
        <MiIcon
          path={mdiCloseCircle}
          size={1}
          color={theme.palette.grey.light}
          aria-hidden="true"
          className={classes.removeIcon}
          onClick={(event) => {
            event.stopPropagation();
            onDelete?.(event);
          }}
        />
      )}
      <DocumentThumbnail
        document={document}
        documentCount={count || 0}
        dimension={40}
        onClick={onClick}
        style={{
          borderRadius: 2,
          border: selected
            ? `2px solid ${theme.palette.primary.main}`
            : `1px solid ${theme.palette.grey.main}`,
        }}
      />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    maxWidth: 200,
    width: "100%",
    position: "relative",
  },
  thumbnailGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    width: "100%",
  },
  smallThumbnail: {
    position: "relative",
    flexShrink: 0,
    borderRadius: 6,
  },
  removeIcon: {
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 1,
    padding: 2,
    borderRadius: "50%",
  },
  uploadButton: {
    maxWidth: 40,
    maxHeight: 40,
    padding: 7,
    color: theme.palette.grey.medium,
    border: "1.125px dashed",
    borderRadius: "4px",
    borderColor: theme.palette.grey.medium,
  },
}));
